// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1jgI7","title":"Header_title__TN6zj","side":"Header_side__LnHz3"};